import { apiRequest } from 'api/apiClient';

const createWidget = async (widgetData) => {
  const response = await apiRequest('POST', '/v1/widgets', widgetData);
  return response;
};

const updateWidget = async ({ uid, ...widgetData }) => {
  const response = await apiRequest('PATCH', `/v1/widgets/${uid}`, widgetData);
  return response;
};

const deleteWidget = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/widgets/${uid}`);
  return response;
};

const WIDGETS_MUTATIONS = {
  CREATE_WIDGET: createWidget,
  UPDATE_WIDGET: updateWidget,
  DELETE_WIDGET: deleteWidget,
};

export default WIDGETS_MUTATIONS;
